<template>
  <div class="dialog-wrap">
    <el-dialog title="查看详情"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               :modal-append-to-body="false"
               @open="open"
               width="1090px">

      <div class="values">
        <div style="display:flex;justify-content: space-between; min-height:60px">
          <el-form class="search-wrap"
                   ref="searchForm"
                   :inline="true"
                   :model="query">
            <el-form-item label="用户ID"
                          prop="anon_user_id_keyword">
              <el-input v-model="query.anon_user_id_keyword"
                        @input="secondaryList(true)"
                        placeholder="请输入关键词"></el-input>
            </el-form-item>
            <el-form-item label="用户IP"
                          prop="ip_keyword">
              <el-input v-model="query.ip_keyword"
                        @input="secondaryList(true)"
                        placeholder="请输入关键词"></el-input>
            </el-form-item>
            <!-- <el-form-item label="请求接口关键字"
                          prop="request_path_keyword">
              <el-input v-model="query.request_path_keyword"
                        @input="secondaryList(true)"
                        placeholder="请输入关键词"></el-input>
            </el-form-item> -->
          </el-form>

        </div>
        <el-table class="table"
                  :data="results"
                  @selection-change="handleSelectionChange"
                  border>
          <el-table-column type="selection"
                           width="50"
                           align="center"
                           fixed="left">
          </el-table-column>
          <el-table-column prop="anon_user_id"
                           label="用户ID"
                           width="230"
                           align="left">
          </el-table-column>
          <el-table-column prop="ip"
                           label="访问ip"
                           width="200"
                           align="center">
          </el-table-column>
          <el-table-column prop="device_type"
                           label="设备类型"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.device_type==1 ?'手机':'PC'}}
            </template>
          </el-table-column>
          <el-table-column prop="os_type"
                           label="操作系统"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.os_type==1">iphone</span>
              <span v-if="scope.row.os_type==2">android</span>
              <span v-if="scope.row.os_type==3">mac</span>
              <span v-if="scope.row.os_type==4">windows</span>
            </template>
          </el-table-column>
          <el-table-column prop="province_info"
                           label="地理位置"
                           width="200"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.province_info}}{{scope.row.city_info}}
            </template>
          </el-table-column>
          <el-table-column prop="request_time"
                           label="访问时间"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              <span>{{  $moment(scope.row.request_time).format('YYYY-MM-DD HH:mm:ss')  }}</span>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { userHttpRequestLog } from '@/api/promotion'
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  watch: {
    isVisible(val) {
      this.dialogVisible = val
    },
    content(val) {
      if (val) {
        this.shortCode = val.short_code
      }
    },
  },
  data() {
    return {
      loading: false,
      title: '',
      dialogVisible: this.visible,
      addVisible: false,
      pageTotal: 10,
      detail: {},
      results: [],
      chooseList: [],
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      shortCode: '',
    }
  },

  methods: {
    handleSelectionChange(val) {
      this.chooseList = val
    },
    open() {
      this.secondaryList(true)
    },
    secondaryList(reset) {
      const params = Object.assign({}, this.query)
      if (reset) {
        params.pageIndex = 1
      }
      params.request_path_str =
        'GET_promotionActivity_short_code_' + this.shortCode
      userHttpRequestLog(params).then((res) => {
        this.results = res.list
        this.pageTotal = res.count
      })
    },
    close() {
      this.addVisible = false
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      this.secondaryList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.secondaryList()
    },
    handleClose() {
      this.$emit('close')
      this.query.pageIndex = 1
    },
  },
}
</script>

<style lang="less" scoped>
.fileStyle {
  position: relative;
  top: 0px;
  margin-right: 20px;
  border-radius: 1px;
  padding: 6px 15px;
  color: #999999;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #999999;
}
::v-deep .el-upload-list {
  display: none !important;
}
.btBox {
  position: relative;
}
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.footer {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
</style>
